import React from 'react';
import './UpdatingOverlay.css';

/**
 * Voile discret « Mise à jour… » affiché pendant un rechargement de données,
 * SANS masquer les chiffres précédents (anti-flicker). Le parent doit porter la
 * classe `rf-surface` (position: relative). Réutilisé par les onglets Reporting.
 */
export default function UpdatingOverlay({ show }) {
  if (!show) return null;
  return (
    <div className="rf-updating" aria-hidden="true">
      <span className="rf-updating-badge">
        <span className="rf-updating-spin" /> Mise à jour…
      </span>
    </div>
  );
}
